import React from "react";
import { useTranslation } from "react-i18next";
import GuardianScoreGauge from "./GuardianScoreGauge";

/**
 * QENVA · Guardian Score Gauge for the Dashboard Hero.
 *
 * Thin wrapper around the canonical `GuardianScoreGauge` — same
 * excellent/good/caution/at_risk → color map, SVG arc, and glow (per
 * DESIGN.md's No-Siren Rule: at_risk is muted rose #FF6B7A, never pure red).
 * There is exactly one Guardian Score rendering in the codebase; this just
 * sizes it up for the hero and adds the "+X pts ce mois" delta line the hero
 * context needs underneath.
 */
export default function GuardianScoreHeroGauge({
  value = 0,
  band = "good",
  delta = 0,
  size = 220,
  testId = "guardian-score-hero-gauge",
}) {
  const { t } = useTranslation("dashboard");
  return (
    <div className="flex flex-col items-center gap-2" data-testid={testId}>
      <GuardianScoreGauge value={value} band={band} size={size} testId={`${testId}-gauge`} />
      {Number.isFinite(delta) && delta !== 0 && (
        <span
          className={`text-[12px] font-semibold ${delta > 0 ? "text-emerald-300" : "text-rose-300"}`}
          data-testid={`${testId}-delta`}
        >
          {delta > 0 ? "↗" : "↘"} {delta > 0 ? "+" : ""}
          {delta} {t("score_delta_suffix")}
        </span>
      )}
    </div>
  );
}
